/** @jsx jsx */

import { useState } from 'react';

import { Spacing } from '@zapier/theme';
import { LegacyButton, Margin } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { KeyValue } from 'app/developer-v3/components/KeyValueEditor';
import type { RequestOptions } from 'app/developer-v3/platformSchema/request';

import RequestFields from '../RequestFields';

const Styles = {
  showOptions: css`
    padding-right: ${Spacing.medium}px;
    padding-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  `,
};

type Props = {
  body: {};
  disabledTabs: Array<'body' | 'options'>;
  headers: {};
  initialActiveTab?: number;
  onChangeBody: (items: Array<KeyValue>) => void;
  onChangeHeaders: (items: Array<KeyValue>) => void;
  onChangeOptions: (name: string, value: boolean) => void;
  onChangeParams: (items: Array<KeyValue>) => void;
  params: {};
  removeMissingValuesFrom: RequestOptions;
};

const AdvancedSettings = ({
  body,
  disabledTabs,
  headers,
  initialActiveTab,
  onChangeBody,
  onChangeHeaders,
  onChangeOptions,
  onChangeParams,
  params,
  removeMissingValuesFrom,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div css={Styles.showOptions}>
        <LegacyButton
          color="secondary"
          iconBefore={isOpen ? 'arrowSmallUp' : 'arrowSmallDown'}
          onClick={() => setIsOpen(!isOpen)}
          onKeyDown={() => setIsOpen(!isOpen)}
        >
          {isOpen ? 'Hide Options' : 'Show Options'}
        </LegacyButton>
      </div>
      {isOpen && (
        <Margin margin="10px 10px 20px 10px">
          <RequestFields
            body={body}
            disabledTabs={disabledTabs}
            headers={headers}
            initialActiveTab={initialActiveTab}
            isDisabledRequestTemplate={true}
            onChangeBody={onChangeBody}
            onChangeHeaders={onChangeHeaders}
            onChangeOptions={onChangeOptions}
            onChangeParams={onChangeParams}
            params={params}
            removeMissingValuesFrom={removeMissingValuesFrom}
          />
        </Margin>
      )}
    </div>
  );
};

export default AdvancedSettings;
